<template>
    <div class="mine-container">
        <!-- 电脑端样式 -->
        <div v-if="isDesktop" class="desktop-container">
            <div class="content">
                <el-form :model="dataForm" :rules="dataFormRules" ref="dataForm" label-position="right">
                    <el-form-item label="旧密码:" prop="password">
                        <el-input v-model="dataForm.password" type="password" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码:" prop="new_password">
                        <el-input v-model="dataForm.new_password" type="password" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码:" prop="checkpassword">
                        <el-input v-model="dataForm.checkpassword" type="password" auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div class="footer">
                    <el-button type="primary" @click.native="handleUpdataPw('dataForm')">确认</el-button>
                    <el-button @click="handleCancel">取消</el-button>
                </div>
            </div>
        </div>

        <!-- 手机端样式 -->
        <div v-else class="mobile-container">
            <div class="mobile-content">
                <div class="mobile-title">修改密码</div>
                <div class="mobile-form">
                    <div class="form-item">
                        <div class="form-label">旧密码</div>
                        <van-field
                            v-model="dataForm.password"
                            type="password"
                            placeholder="请输入旧密码"
                            :rules="[{ required: true, message: '请输入旧密码' }]"
                        />
                    </div>
                    <div class="form-item">
                        <div class="form-label">新密码</div>
                        <van-field
                            v-model="dataForm.new_password"
                            type="password"
                            placeholder="请输入新密码"
                            :rules="[{ required: true, message: '请输入新密码' }]"
                        />
                    </div>
                    <div class="form-item">
                        <div class="form-label">确认密码</div>
                        <van-field
                            v-model="dataForm.checkpassword"
                            type="password"
                            placeholder="请确认新密码"
                            :rules="[
                                { required: true, message: '请再次输入密码' },
                                { validator: checkNewPw, message: '密码不一致' }
                            ]"
                        />
                    </div>
                </div>
                <div class="mobile-footer">
                    <van-button type="default" @click="handleCancel" block>取消</van-button>
                    <van-button type="primary" @click="handleMobileUpdataPw" block style="margin-top: 10px;">确认</van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {editPassword} from "@/api/system.js";
import { Toast } from 'vant';

export default{
    data(){
         var checkNewPw = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请再次输入密码'));
            }
            if (this.dataForm.new_password !== value) {
                return callback(new Error("密码不一致"));
            } else {
                return callback();
            }
        };
        return{
            // 响应式设计变量
            isDesktop: true,
            dataForm: {
              password: '',
              new_password: '',
              checkpassword: ''
            },
            dataFormRules: {
              password: [{
                required: true,
                message: '请输入旧密码',
                trigger: 'blur'
              }],
              new_password: [{
                required: true,
                message: '请输入新密码',
                trigger: 'blur'
              }],
              checkpassword: [{
                required: true,
                validator: checkNewPw,
                trigger: 'blur'
              }]
            }
        }
    },
    mounted(){
        this.checkScreenSize();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy(){
        window.removeEventListener('resize', this.handleResize);
    },
    methods:{
        // 检查屏幕尺寸
        checkScreenSize() {
            this.isDesktop = window.innerWidth > 768;
        },
        // 处理窗口大小变化
        handleResize() {
            this.checkScreenSize();
        },
        // 取消操作
        handleCancel() {
            // 重置表单
            if (this.$refs.dataForm) {
                this.$refs.dataForm.resetFields();
            }
            this.dataForm = {
                password: '',
                new_password: '',
                checkpassword: ''
            };
        },
        // 电脑端修改密码
        handleUpdataPw(dataForm) {
            this.$refs[dataForm].validate(valid => {
                if (valid) {
                    this.updatePassword();
                } else {
                    return false;
                }
            });
        },
        // 手机端修改密码
        handleMobileUpdataPw() {
            // 简单验证
            if (!this.dataForm.password) {
                Toast('请输入旧密码');
                return;
            }
            if (!this.dataForm.new_password) {
                Toast('请输入新密码');
                return;
            }
            if (this.dataForm.new_password !== this.dataForm.checkpassword) {
                Toast('密码不一致');
                return;
            }
            this.updatePassword();
        },
        // 统一的修改密码方法
        updatePassword() {
            editPassword(this.dataForm).then(res => {
                if (res.code === 200) {
                    if (this.isDesktop) {
                        this.$message({
                            message: "修改成功",
                            type: "success"
                        });
                    } else {
                        Toast("修改成功");
                    }
                    localStorage.removeItem('userAccount');
                    localStorage.removeItem('token');
                    localStorage.removeItem('currentMenu');
                    this.$router.push({name:'home'});
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
/* 基础样式 */
.mine-container {
    width: 100%;
    min-height: 100vh;
    background-color: #f5f7fa;
    padding: 20px;
    box-sizing: border-box;
}

/* 电脑端样式 */
.desktop-container {
    max-width: 500px;
    margin: 50px auto;
}

.desktop-container .content {
    background-color: white;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.desktop-container .footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    gap: 10px;
}

/* 手机端样式 */
.mobile-container {
    width: 100%;
}

.mobile-content {
    background-color: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.mobile-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 20px;
    text-align: center;
}

.mobile-form {
    margin-bottom: 20px;
}

.form-item {
    margin-bottom: 20px;
}

.form-label {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    margin-bottom: 8px;
    display: block;
}

.mobile-footer {
    margin-top: 20px;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .mine-container {
        padding: 10px;
    }
    
    .mobile-content {
        padding: 15px;
    }
}

@media (min-width: 769px) {
    .desktop-container .content {
        padding: 30px;
    }
}
</style>
